/**
 * class dependency:
 * - MoveTool
 */

function MovePathTool(draw, line, point1Object, point2Object, callback) {
    var _this = this;

    this.draw = draw;
    this.line = line;
    this.point1Object = point1Object;
    this.point2Object = point2Object;

    var position = this.line.array().value;
    var pointRadius = 5;

    if (this.point1Object === undefined) {
        this.point1Object = this.draw.circle();

        this.point1Object.radius(pointRadius);
        this.point1Object.fill("rgba(0, 0, 0, 0.3)");
        this.point1Object.move(position[0][0], position[0][1]);
    }

    if (this.point2Object === undefined) {
        this.point2Object = this.draw.circle();

        this.point2Object.radius(pointRadius);
        this.point2Object.fill("rgba(0, 0, 0, 0.3)");
        this.point2Object.move(position[1][0], position[1][1]);
    }

    var activateEvent = function() {
        var point1MoveTool = new MoveTool(_this.point1Object, false, function(pos) {
            _this.line.plot(pos.x, pos.y);

            if (typeof callback === "function") {
                callback(pos);
            }
        });

        var point2MoveTool = new MoveTool(_this.point2Object, false, function(pos) {
            _this.line.plot([[], [pos.x, pos.y]]);

            if (typeof callback === "function") {
                callback(pos);
            }
        });
    };

    activateEvent();
}